require('./builders/study_group_members_builder.ts');
require('./builders/study_group_priority_feed_builder.ts');
require('./commands/add_user_to_study_group_command.ts');
require('./commands/clear_all_selected_users_command.ts');
require('./commands/delete_user_from_study_group_command.ts');
require('./commands/dismiss_study_buddy_tile_command.ts');
require('./commands/get_study_buddy_priority_feed_command.ts');
require('./commands/load_study_group_members_command.ts');
require('./commands/load_study_groups_command.ts');
require('./commands/select_all_users_command.ts');
require('./commands/select_user_command.ts');
require('./components/study_group_buddies/study_group_buddies_component.ts');
require('./components/study_group_join/study_group_join.ts');
require('./components/study_group_section_tile/study_group_section_tile_component.ts');
require('./components/study_group_terms/study_group_terms_component.ts');
require('./datasources/study_group_courses_datasource.ts');
require('./datasources/study_group_members_datasource.ts');
require('./datasources/study_group_sections_datasource.ts');
require('./datasources/study_group_terms_datasource.ts');
require('./datasources/study_groups_datasource.ts');
require('./datasources/study_groups_priority_feed_datasource.ts');
require('./modals/study_group_description_modal/study_group_description_modal.ts');
require('./modals/study_group_joining_modal/study_group_joining_modal.ts');
require('./modals/study_group_emailing_modal/study_group_emailing_modal.ts');
require('./modals/study_groups_modal_service.ts');
require('./queries/study_group_members_query.ts');
require('./queries/study_groups_priority_feed_query.ts');
require('./queries/study_groups_query.ts');
require('./servants/study_groups_email_servant.ts');
require('./study_group_interfaces.ts');
require('./study_groups_configuration.ts');
require('./study_groups_routes.ts');
require('./views/study_group_members/study_group_members_controller.ts');
require('./views/study_groups/study_groups_controller.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/core.ts